import React, { useEffect } from 'react';


import "./Hull.scss";
import { Router } from '../../pages/Router';


export const Hull = () => {
  return (
    <Router className="Hull" transition={500} transitionPrefix="page"/>
  )
}

export default Hull
